export default function styles(theme) {
  return {
    title: {
      fontSize: "3rem",
      textAlign:"left",
      width: "100%",
      letterSpacing: "1px",
      color: theme.palette.text.primary,
      margin: "0rem",
      padding:"3rem 0rem 1rem",
      [theme.breakpoints.down("sm")]: {
        fontSize:  "2rem",
      },
    },
    centerPara:{
      textAlign: 'center',
      color: theme.palette.text.tertiary,
      maxWidth: "60%",
      margin: '10px auto',
      fontSize: "1rem",
      lineHeight:'1.6rem',
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
      },
    },
    section: {
      alignItems: "center",
      justifyContent: "center"
    },
    description: {
      textAlign: 'left',
      color: theme.palette.text.tertiary,
      maxWidth: "60%",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
        marginBottom: '2rem'
      },
    },
    cardSection: {
      height: "auto",
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr",
      margin: "3rem 0rem",
      gap: 20,
      [theme.breakpoints.down("md")]: {
        gridTemplateColumns: "1fr 1fr",
      },
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: " 1fr",
        margin: "2rem 0rem",
      }
    },

    productsGrid:{
      marginBottom: 80,
      [theme.breakpoints.down("sm")]: {
        marginBottom: 40,
      }
    }
  };
}
